export default __webpack_public_path__ + "dc26519.png";